import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {DevilsCrossRoadSound} from "../sound/DevilsCrossRoadSound";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";


export class FreespinUnlockableAreasView extends PIXI.Container implements StageLayer {

    private _topOverlays: PIXI.Sprite [] = [];
    private _topTexts: PIXI.Text [] = [];

    private _rightOverlays: PIXI.Sprite [] = [];
    private _rightTexts: PIXI.Text [] = [];

    private _currentTopFeatureIdleLoopActives: PIXI.spine.Spine [] = [];
    private _currentRightFeatureIdleLoopActives: PIXI.spine.Spine [] = [];

    private _topSpines:PIXI.spine.Spine [] = [];
    private _rightSpines:PIXI.spine.Spine [] = [];

    private _textStyle: PIXI.TextStyle = new PIXI.TextStyle({
        fill : 0xFFBF00,
        fontFamily : OpenSans.FAMILY,
        wordWrap : false,
        fontWeight : FontWeight.BOLD,
        fontSize : 46
    });

    private _topHighlights: PIXI.Sprite [] = [];
    private _rightHighlights: PIXI.Sprite [] = [];

    private _spinsLeftIndicatorsOuter: PIXI.Sprite [] = [];
    private _spinsLeftIndicatorsInner: PIXI.Sprite [] = [];

    private _heartIndicatorSpine: PIXI.spine.Spine;

    private _fsCandle: PIXI.spine.Spine;

    private _reelFrameOverlay: PIXI.Sprite;

    private _unlockedTopAreas: boolean [] = [false, false, false, false, false];
    private _unlockedRightAreas: boolean [] = [false, false, false, false, false];
    private _restored:boolean = false;

    private _activeAnimStrTop: string [] = ["","","","",""];
    private _activeAnimStrRight: string [] = ["","","","",""];
    private _heartCounterOverlay: PIXI.Sprite;
    private _spinsFullCounter: number = 0;

    private _verticalEffects: TimelineSprite [] = [];
    private _horizontalEffects: TimelineSprite [] = [];

    public getUnlockedTopAreas():boolean [] {
        return this._unlockedTopAreas;
    }

    public getUnlockedRightAreas():boolean [] {
        return this._unlockedRightAreas;
    }

    constructor() {
        super();

        this.name = "freespinUnlockableView";

        this.createLockedAreas();
        this.createEyeSpines();
        //this.createSpinsLeftIndicators();
        this.createHeartIndicator();
        this.createVerticalEffects();
        this.createHorizontalEffects();

        this.hide();
        this.onOrientationChanged();
    }

    setupForRestore(alignment:string, activated: boolean []):void {
        this._restored = true;
        activated.forEach((bool, blockID) => {
            if(bool) {
                this.unlockOnRestore(alignment, blockID);
            }
        });
    }

    public playVertEffect(id:number): void {

        if(id > -1) {
            this._verticalEffects[id].getAnimationAutoShowHide();
        }
    }

    public playHorzEffect(id:number): void {

        if(id > -1) {
            this._horizontalEffects[id].getAnimationAutoShowHide();
        }
    }

    private createVerticalEffects():void {
        const xOffset:number = -35;
        const yOffset:number = 80;

        [0,1,2,3,4].forEach((vId) => {
            const tls:TimelineSprite = new TimelineSprite(DevilsCrossRoad.assetLoader.getTextures("fs_reel_flowfx"));
            tls.blendMode = PIXI.BLEND_MODES.ADD;
            //tls.playLoop();
            tls.position.set(
                xOffset + (vId * 120),
                yOffset
            );

            this._verticalEffects.push(tls);
            this.addChild(tls);
        });
    }
    private resizeVert(orientation:string): void {
        const xOffsetLand:number = -35;
        const yOffsetLand:number = 80;

        const xOffsetPort:number = 25;
        const yOffsetPort:number = 50;

        if(orientation === "landscape") {
            this._verticalEffects.forEach((tls, vId) => {
                tls.position.set(
                    xOffsetLand + (vId * 120),
                    yOffsetLand
                );
            });
        }
        else {
            this._verticalEffects.forEach((tls, vId) => {
                tls.position.set(
                    xOffsetPort + (vId * 120),
                    yOffsetPort
                );
            });
        }
    }

    private createHorizontalEffects():void {
        const xOffset:number = -18;
        const yOffset:number = 172;

        [0,1,2,3,4].forEach((hId) => {
            const tls:TimelineSprite = new TimelineSprite(DevilsCrossRoad.assetLoader.getTextures("fs_reel_flowfx_horizontal"));
            tls.blendMode = PIXI.BLEND_MODES.ADD;
            //tls.playLoop();
            tls.position.set(
                xOffset,
                yOffset + (hId * 100)
            );

            this._horizontalEffects.push(tls);
            this.addChild(tls);
        });
    }
    private resizeHorz(orientation:string): void {
        const xOffsetLand:number = -18;
        const yOffsetLand:number = 170;

        const xOffsetPort:number = 42;
        const yOffsetPort:number = 143;

        if(orientation === "landscape") {
            this._horizontalEffects.forEach((tls, hId) => {
                tls.position.set(
                    xOffsetLand,
                    yOffsetLand + (hId * 99.5)
                );
            });
        }
        else {
            this._horizontalEffects.forEach((tls, hId) => {
                tls.position.set(
                    xOffsetPort,
                    yOffsetPort + (hId * 100)
                );
            });
        }
    }

    private createHeartIndicator():void {
        /*
            Animation {name: 'idle', timelines: Array(1), timelineIds: Array(67108866), duration: 0.800000011920929}
            Animation {name: 'idle_1', timelines: Array(3), timelineIds: Array(83886085), duration: 0.800000011920929}
            Animation {name: 'idle_2', timelines: Array(5), timelineIds: Array(83886085), duration: 0.800000011920929}
            Animation {name: 'idle_3', timelines: Array(7), timelineIds: Array(83886085), duration: 0.800000011920929}
         */
        this._heartIndicatorSpine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("fsHeartIndicator"));
        //console.log("HEART IND: ANIM", this._heartIndicatorSpine.state.data.skeletonData.animations);
        this._heartIndicatorSpine.scale.set(0.5, 0.5);

        this._heartIndicatorSpine.stateData.setMix("idle", "idle_1", 0.25);
        this._heartIndicatorSpine.stateData.setMix("idle_1", "idle_2", 0.25);
        this._heartIndicatorSpine.stateData.setMix("idle_2", "idle_3", 0.25);

        this._heartIndicatorSpine.stateData.setMix("idle_3", "idle", 0.25);
        this._heartIndicatorSpine.stateData.setMix("idle_2", "idle_1", 0.25);
        this._heartIndicatorSpine.stateData.setMix("idle_1", "idle", 0.25);

        this._heartCounterOverlay = new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures("FS/heart_counter_white")[0]);
        this._heartCounterOverlay.scale.set(0.5, 0.5);
        this._heartCounterOverlay.anchor.set(0.5, 0.5);
        this._heartCounterOverlay.alpha = 0;

        //gsap.timeline({repeat: -1}).
        //add(() => {this._heartIndicatorSpine.state.setAnimation(0, "idle", true)}, "+=1").
        //add(() => {this._heartIndicatorSpine.state.setAnimation(0, "idle_1", true)}, "+=1").
        //add(() => {this._heartIndicatorSpine.state.setAnimation(0, "idle_2", true)}, "+=1").
        //add(() => {this._heartIndicatorSpine.state.setAnimation(0, "idle_3", true)}, "+=1")

        this.addChild(this._heartIndicatorSpine);
        this.addChild(this._heartCounterOverlay);
        this.resetIndicator();
    }

    private createSpinsLeftIndicators():void {
        const topOuter:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        const middleOuter:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        const bottomOuter:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._spinsLeftIndicatorsOuter.push(topOuter, middleOuter, bottomOuter);

        const topInner:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        const middleInner:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        const bottomInner:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._spinsLeftIndicatorsInner.push(topInner, middleInner, bottomInner);

        this._spinsLeftIndicatorsOuter.forEach((sprite, index) => {
            sprite.tint = 0xCCCCCC;
            sprite.width = 60;
            sprite.height = 60;

            sprite.x = -220;
            sprite.y = 40 + (index * (sprite.height + 10));

            this.addChild(sprite);
        });

        this._spinsLeftIndicatorsInner.forEach((sprite, index) => {
            sprite.tint = 0xAA55AA;
            sprite.scale.set(0.8, 0.8);
            sprite.anchor.set(-0.125, -0.125);
            this._spinsLeftIndicatorsOuter[index].addChild(sprite);
        });
    }

    public resetIndicator():void {
        this._heartIndicatorSpine.state.setAnimation(0, "idle_3", true);
    }

    public setIndicator(nrOfSpins:number): void {
        switch (nrOfSpins) {
            case 0:

                this._heartIndicatorSpine.state.setAnimation(0, "idle_3", true);
                DevilsCrossRoad.keypadPlugin.setZeroBetSpinCounter(nrOfSpins);
                break;
            case 1:

                this._heartIndicatorSpine.state.setAnimation(0, "idle_2", true);
                DevilsCrossRoad.keypadPlugin.setZeroBetSpinCounter(nrOfSpins);
                break;
            case 2:

                this._heartIndicatorSpine.state.setAnimation(0, "idle_1", true);
                DevilsCrossRoad.keypadPlugin.setZeroBetSpinCounter(nrOfSpins);
                break;
            case 3:
                this._spinsFullCounter++;
                if (this._spinsFullCounter === 1) {
                    this.blinkHeart();
                    DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_SPINS_RESET});
                    this._heartIndicatorSpine.state.setAnimation(0, "idle", true);
                }
                DevilsCrossRoad.keypadPlugin.setZeroBetSpinCounter(nrOfSpins);
                break;
        }
    }

    private blinkHeart():void {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.fromTo(this._heartCounterOverlay, 0.1, {alpha: 0, ease : "power3.out"}, {alpha:  0.6})).add(() => {
            this._heartCounterOverlay.alpha = 0;
        });
    }

    public resetFeatureAnimations(): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        this._topTexts.forEach((text, index) => {
            tl.add(() => {
                this._topTexts[index].visible = false;
                this._topTexts[index].text = "";
            });
        });
        this._rightTexts.forEach((text, index) => {
            tl.add(() => {
                this._rightTexts[index].visible = false;
                this._rightTexts[index].text = "";
            });
        });

        return tl;
    }

    public resetEyeAnimations(index:number = -1, alignment?:string): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        if(index < 0) {
            this._topSpines.forEach((spine, index) => {
                spine.state.setAnimation(0, "closed", true);
                spine.state.setEmptyAnimation(1, 0);
                this._unlockedTopAreas[index] = false;
            });

            this._rightSpines.forEach((spine, index) => {
                spine.state.setAnimation(0, "closed", true);
                spine.state.setEmptyAnimation(1, 0);
                this._unlockedRightAreas[index] = false;
            });
        }
        else if(alignment && alignment === "top") {
            tl.add(() => {this._topSpines[index].state.setAnimation(0, "closed", true)});
            tl.add(() => {this._topSpines[index].state.setEmptyAnimation(1, 0)});

            const trackIndex:number = 0;
            const animation1:PIXI.spine.core.Animation = this._topSpines[index].spineData.findAnimation("activate");
            const animation2:PIXI.spine.core.Animation = this._topSpines[index].spineData.findAnimation("active_idle");
            const animationAlpha:number = 1;
            const mixDuration:number = 0;

            tl.add(() => SpineGSAPWrapper.setAnimation(this._topSpines[index], trackIndex, animation1, false, animationAlpha, mixDuration));
            tl.add(() => SpineGSAPWrapper.setAnimation(this._topSpines[index], trackIndex, animation2, true, animationAlpha, mixDuration), animation1.duration);
            tl.add(() => {
                this._unlockedTopAreas[index] = false;
            });
        }
        else if(alignment && alignment === "right") {
            tl.add(() => {this._rightSpines[index].state.setAnimation(0, "closed", true)});
            tl.add(() => {this._rightSpines[index].state.setEmptyAnimation(1, 0)});

            const trackIndex:number = 0;
            const animation1:PIXI.spine.core.Animation = this._rightSpines[index].spineData.findAnimation("activate");
            const animation2:PIXI.spine.core.Animation = this._rightSpines[index].spineData.findAnimation("active_idle");
            const animationAlpha:number = 1;
            const mixDuration:number = 0;

            tl.add(() => SpineGSAPWrapper.setAnimation(this._rightSpines[index], trackIndex, animation1, false, animationAlpha, mixDuration));
            tl.add(() => SpineGSAPWrapper.setAnimation(this._rightSpines[index], trackIndex, animation2, true, animationAlpha, mixDuration), animation1.duration);
            tl.add(() => {
                this._unlockedRightAreas[index] = false;
            });
        }

        return tl;
    }

    public playFeatureInEye(alignment:string, blockId:number, featureName:string, featSpecificString:string = ""):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        if(alignment === "top" && this._topSpines[blockId]) {
            const trackIndex:number = 1;
            const fsps:string = (featSpecificString !== "")? "_" + featSpecificString : "";
            const animFeature:PIXI.spine.core.Animation = this._topSpines[blockId].spineData.findAnimation("feature_" + featureName + fsps);
            const animationAlpha:number = 1;
            const mixDuration:number = 0;

            this._activeAnimStrTop[blockId] = "feature_" + featureName + fsps;

            tl.add(() => SpineGSAPWrapper.setAnimation(this._topSpines[blockId], trackIndex, animFeature, false, animationAlpha, mixDuration));
            tl.add(() => {}, animFeature.duration);
        }
        else if(alignment === "right" && this._rightSpines[blockId]) {
            const trackIndex:number = 1;
            const fsps:string = (featSpecificString !== "")? "_" + featSpecificString : "";
            const animFeature:PIXI.spine.core.Animation = this._rightSpines[blockId].spineData.findAnimation("feature_" + featureName + fsps);
            const animationAlpha:number = 1;
            const mixDuration:number = 0;

            this._activeAnimStrRight[blockId] = "feature_" + featureName + fsps;

            tl.add(() => SpineGSAPWrapper.setAnimation(this._rightSpines[blockId], trackIndex, animFeature, false, animationAlpha, mixDuration));
            tl.add(() => {}, animFeature.duration);
        }

        return tl;
    }



    public stopEyeFeatureIdleLoop(spine: PIXI.spine.Spine): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            spine.state.setEmptyAnimation(1, 0);
        });

        return tl;
    }


    public playEyeFeatureIdle(alignment:string, blockId:number, featureName:string, featSpecificString:string = ""): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        const trackIndex:number = 1;
        const animationAlpha:number = 1;
        const mixDuration:number = 0;
        let featStr:string = "";
        if(featSpecificString !== "") {
            featStr = "_"+ featSpecificString + "_idle";
        }
        else {
            featStr = "_idle";
        }
        const featStringIdle: string = "feature_" + featureName + featStr;

        if(alignment === "top") {
            const animFeatureFeatureIdle:PIXI.spine.core.Animation = this._topSpines[blockId].spineData.findAnimation(featStringIdle);

            tl.add([
                () => {
                    this._currentTopFeatureIdleLoopActives.push(this._topSpines[blockId]);
                },
                () => SpineGSAPWrapper.setAnimation(this._topSpines[blockId], trackIndex, animFeatureFeatureIdle, true, animationAlpha, mixDuration)
            ]);

        }
        else if(alignment === "right") {
            const animFeatureFeatureIdle:PIXI.spine.core.Animation = this._rightSpines[blockId].spineData.findAnimation(featStringIdle);

            tl.add([
                () => {
                    this._currentRightFeatureIdleLoopActives.push(this._rightSpines[blockId]);
                },
                () => SpineGSAPWrapper.setAnimation(this._rightSpines[blockId], trackIndex, animFeatureFeatureIdle, true, animationAlpha, mixDuration)
            ]);
        }

        return tl;
    }

    public playEyeFeature(alignment:string, blockId:number, featureName:string, isGOAT:boolean = false, featSpecificString:string = ""): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        if(alignment === "top") {
            const trackIndex:number = 0;
            const animFeatureActivate:PIXI.spine.core.Animation = this._topSpines[blockId].spineData.findAnimation("feature_activate");
            const animFeatureActive:PIXI.spine.core.Animation = this._topSpines[blockId].spineData.findAnimation("feature_active");

            const animationAlpha:number = 1;
            const mixDuration:number = 0;

            tl.add([
            (!this._unlockedTopAreas[blockId])?
                () => SpineGSAPWrapper.setAnimation(this._topSpines[blockId], trackIndex, animFeatureActivate, false, animationAlpha, mixDuration) : () => {},
                //DevilsCrossRoad.freespinReelAreaView.playVerticalSequence(blockId)
            ]);
            tl.add(()=>{DevilsCrossRoadSound.soundPlayer.playTrack({name:DevilsCrossRoadSound.FS_FEATURE_REVEAL_FLASH})},"<")
            tl.add(() => SpineGSAPWrapper.setAnimation(this._topSpines[blockId], trackIndex, animFeatureActive, true, animationAlpha, mixDuration), animFeatureActivate.duration);



        }
        else if(alignment === "right") {
            const trackIndex:number = 0;
            const animFeatureActivate:PIXI.spine.core.Animation = this._rightSpines[blockId].spineData.findAnimation("feature_activate");
            const animFeatureActive:PIXI.spine.core.Animation = this._rightSpines[blockId].spineData.findAnimation("feature_active");

            const animationAlpha:number = 1;
            const mixDuration:number = 0;

            tl.add([
                (!this._unlockedRightAreas[blockId])?
                () => SpineGSAPWrapper.setAnimation(this._rightSpines[blockId], trackIndex, animFeatureActivate, false, animationAlpha, mixDuration) : () => {},
                //DevilsCrossRoad.freespinReelAreaView.playHorizontalSequence(blockId)
            ]);
            tl.add(()=>{DevilsCrossRoadSound.soundPlayer.playTrack({name:DevilsCrossRoadSound.FS_FEATURE_REVEAL_FLASH})},"<");
            tl.add(() => SpineGSAPWrapper.setAnimation(this._rightSpines[blockId], trackIndex, animFeatureActive, true, animationAlpha, mixDuration), animFeatureActivate.duration);
        }


        return tl;
    }

    private createEyeSpines(): void {
        const startXtop:number = 55;
        const startYtop:number = 140;
        const startYright:number = 235;

        const areaWidth:number = 120;
        const areaHeight:number = 100;

        [0, 1, 2, 3, 4].forEach((value) => {
            const spineTop:PIXI.spine.Spine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("fs_feature"));

            spineTop.position.set(startXtop + (value * areaWidth), startYtop);
            spineTop.state.setAnimation(0, "closed", true);
            this._topSpines.push(spineTop);
            this.addChild(spineTop);

            const topText: PIXI.Text = new PIXI.Text("Xx", this._textStyle);
            topText.position.set(startXtop + (value * areaWidth), startYtop);
            topText.anchor.set(0.5, 0.5);
            topText.visible = false;
            this._topTexts.push(topText);
            this.addChild(topText);

            this.createHighlightOverlay("top", new PIXI.Point(spineTop.position.x, spineTop.position.y),
                new PIXI.Point(areaWidth, areaHeight)
            );

            const spineRight:PIXI.spine.Spine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("fs_feature"));
            spineRight.position.set(660, startYright + (value * areaHeight));
            //console.log("Spine feature animations", spineRight.state.data.skeletonData.animations);
            spineRight.state.setAnimation(0, "closed", true);
            this._rightSpines.push(spineRight);
            this.addChild(spineRight);

            const rightText: PIXI.Text = new PIXI.Text("Xx", this._textStyle);
            rightText.position.set(660, startYright + (value * areaHeight));
            rightText.anchor.set(0.5, 0.5);
            rightText.visible = false;
            this._rightTexts.push(rightText);
            this.addChild(rightText);

            this.createHighlightOverlay("right", new PIXI.Point(spineRight.position.x, spineRight.position.y),
                new PIXI.Point(areaWidth, areaHeight)
            );

        });
    }

    public clearAllTrackOneFeatAnims(): void {
        this._topSpines.forEach((spine, index) => {
            if(this._unlockedTopAreas[index]) {
                SpineGSAPWrapper.clearAnimation(spine, 1, 0.2);
            }
        })
        this._rightSpines.forEach((spine, index) => {
            if(this._unlockedRightAreas[index]) {
                SpineGSAPWrapper.clearAnimation(spine, 1, 0.2);
            }
        })
    }

    public playAfterFeatureRun(alignment:string, blockId:number, isGOAT:boolean = false): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        // TODO: Add "_feature_used", dimmed down animation of feature indicator

        if(alignment === "top") {
            const trackIndex:number = 0;
            const featureDeactivate:PIXI.spine.core.Animation = this._topSpines[blockId].spineData.findAnimation("feature_deactivate");
            const animation1:PIXI.spine.core.Animation = this._topSpines[blockId].spineData.findAnimation("feature_active");
            const animation2:PIXI.spine.core.Animation = this._topSpines[blockId].spineData.findAnimation((isGOAT)? "feature_deactivate" : "feature_active");
            const animationAlpha:number = 1;
            const mixDuration:number = 0;
            let usedAnimDur: number = 1.1;

            //tl.add(() => SpineGSAPWrapper.setAnimation(this._topSpines[blockId], 1, animation1, false, animationAlpha, mixDuration));
            if(!isGOAT) {
                //tl.add(() => SpineGSAPWrapper.setAnimation(this._topSpines[blockId], trackIndex, animation1, false, animationAlpha, mixDuration), featureDeactivate.duration);

                if(this._activeAnimStrTop[blockId] !== "") {
                    const featureUsed:PIXI.spine.core.Animation = this._topSpines[blockId].spineData.findAnimation(this._activeAnimStrTop[blockId] + "_idle_used");
                    tl.add(() => SpineGSAPWrapper.setAnimation(this._topSpines[blockId], 1, featureUsed, true, animationAlpha, 0.2), animation1.duration + 0.9);

                }
            }
            else {
                tl.add(() => SpineGSAPWrapper.setAnimation(this._topSpines[blockId], trackIndex, animation2, (!isGOAT), animationAlpha, mixDuration),
                    featureDeactivate.duration + animation1.duration + usedAnimDur);
            }

            if(!isGOAT) {
                tl.add(() => {
                    this._unlockedTopAreas[blockId] = true;
                });
            } else {
                tl.add([
                    this.resetEyeAnimations(blockId, alignment),
                    DevilsCrossRoad.freespinReelAreaView.resetVerticalGlow(blockId)
                ], featureDeactivate.duration + animation1.duration + usedAnimDur);
            }
        }
        else if(alignment === "right") {
            const trackIndex:number = 0;
            const featureDeactivate:PIXI.spine.core.Animation = this._rightSpines[blockId].spineData.findAnimation("feature_deactivate");
            const animation1:PIXI.spine.core.Animation = this._rightSpines[blockId].spineData.findAnimation("feature_active");
            const animation2:PIXI.spine.core.Animation = this._rightSpines[blockId].spineData.findAnimation((isGOAT)? "feature_deactivate" : "feature_active");
            const animationAlpha:number = 1;
            const mixDuration:number = 0;
            let usedAnimDur: number = 1.1;

            //tl.add(() => SpineGSAPWrapper.setAnimation(this._rightSpines[blockId], 1, animation1, false, animationAlpha, mixDuration));
            if(!isGOAT) {
                //tl.add(() => SpineGSAPWrapper.setAnimation(this._rightSpines[blockId], trackIndex, animation1, false, animationAlpha, mixDuration), featureDeactivate.duration);

                if(this._activeAnimStrRight[blockId] !== "") {
                    const featureUsed:PIXI.spine.core.Animation = this._rightSpines[blockId].spineData.findAnimation(this._activeAnimStrRight[blockId] + "_idle_used");
                    tl.add(() => SpineGSAPWrapper.setAnimation(this._rightSpines[blockId], 1, featureUsed, true, animationAlpha, 0.2), animation1.duration + 0.9);
                }
            }
            else {
                tl.add(() => SpineGSAPWrapper.setAnimation(this._rightSpines[blockId], trackIndex, animation2, (!isGOAT), animationAlpha, mixDuration),
                    featureDeactivate.duration + animation1.duration + usedAnimDur);
            }

            if(!isGOAT) {
                tl.add(() => {
                    this._unlockedRightAreas[blockId] = true;
                });
            }
            else {
                tl.add([
                    this.resetEyeAnimations(blockId, alignment),
                    DevilsCrossRoad.freespinReelAreaView.resetHorizontalGlow(blockId)
                ], featureDeactivate.duration + animation1.duration + usedAnimDur);
            }
        }
        DevilsCrossRoad.freespinReelAreaView.reels.forEach((reels) => {
            reels.forEach((reel) => {
                tl.add(() => {
                    reel.stopHighlightLoop();
                });
            });
        });

        return tl;
    }

    public activateAnimation(alignment:string): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        if(alignment === "top") {

            this._topSpines.forEach((spine) => {

                const trackIndex:number = 0;
                const animation1:PIXI.spine.core.Animation = spine.spineData.findAnimation("activate");
                const animation2:PIXI.spine.core.Animation = spine.spineData.findAnimation("active_idle");
                const animationAlpha:number = 1;
                const mixDuration:number = 0;

                tl.add(() => SpineGSAPWrapper.setAnimation(spine, trackIndex, animation1, false, animationAlpha, mixDuration));
                tl.add(() =>SpineGSAPWrapper.setAnimation(spine, trackIndex, animation2, true, animationAlpha, mixDuration),">");
            });
        }
        else if(alignment === "right") {

            this._rightSpines.forEach((spine) => {
                const trackIndex:number = 0;
                const animation1:PIXI.spine.core.Animation = spine.spineData.findAnimation("activate");
                const animation2:PIXI.spine.core.Animation = spine.spineData.findAnimation("active_idle");
                const animationAlpha:number = 1;
                const mixDuration:number = 0;

                tl.add(() => SpineGSAPWrapper.setAnimation(spine, trackIndex, animation1, false, animationAlpha, mixDuration));
                tl.add(() => SpineGSAPWrapper.setAnimation(spine, trackIndex, animation2, true, animationAlpha, mixDuration), ">");
            });
        }

        return tl;
    }

    // TODO: Remove locked area placeholdrs completely.
    private createLockedAreas(): void {
        this._reelFrameOverlay = new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures("fs_reel_overlay")[0]);
        this.addChild(this._reelFrameOverlay);

        const startXtop:number = 0;
        const startYtop:number = 80;
        [0, 1, 2, 3, 4].forEach((value) => {
            const topSprite: PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
            topSprite.width = 120;
            topSprite.height = 100;
            topSprite.tint = 0x777777;
            topSprite.position.set(startXtop + (value * topSprite.width), startYtop);
            topSprite.alpha = 0.8;

            this._topOverlays.push(topSprite);

            const startYright:number = 175;
            const rightSprite: PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
            rightSprite.width = 120;
            rightSprite.height = 100;
            rightSprite.tint = 0x777777;
            rightSprite.position.set(600, startYright + (value * rightSprite.height));
            rightSprite.alpha = 0.8;

            this._rightOverlays.push(rightSprite);
        });
    }



    private createHighlightOverlay(alignment: string, pos:PIXI.Point, size:PIXI.Point): void {
        const sprite:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        sprite.position.set(pos.x, pos.y);
        sprite.anchor.set(0.5, 0.5);
        sprite.width = size.x;
        sprite.height = size.y;
        sprite.alpha = 0;

        if(alignment === "top") {
            this._topHighlights.push(sprite);
            this.addChild(sprite);
        }
        else if(alignment === "right") {
            this._rightHighlights.push(sprite);
            this.addChild(sprite);
        }
    }

    public show(top: number [] = [], right: number [] = []): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this.reset(top, right);
            this.visible = true;
        }, 0);

        return tl;
    }

    public hide():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this.visible = false;
            this.reset();
            this.resetFeatureAnimations();
        })

        return tl;
    }

    public reset(top: number [] = [], right: number [] = []): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this.resetIndicator();
            this._unlockedTopAreas = [false, false, false, false, false];
            this._unlockedRightAreas = [false, false, false, false, false];
            DevilsCrossRoad.freespinReelAreaView.resetGlows();
            this._activeAnimStrTop = ["","","","",""];
            this._activeAnimStrRight = ["","","","",""];
        }, 0);

        return tl;
    }

    private unlockOnRestore(area: string, blockId: number): void {
        if (area === "top" && !this._unlockedTopAreas[blockId]) {
            if (this.checkLineFullOfCoins(area, blockId)) {
                this.unlockArea("top", blockId,true);
                //DevilsCrossRoad.freespinReelAreaView.playVerticalSequence(blockId);
            }
        } else if (area === "right" && !this._unlockedRightAreas[blockId]) {
            if(this.checkLineFullOfCoins(area,blockId)){
                this.unlockArea("right", blockId,true);
                //DevilsCrossRoad.freespinReelAreaView.playHorizontalSequence(blockId);
            }
        }
    }

    private checkLineFullOfCoins(area: string, blockId: number): boolean {
        let isLineFull: boolean = false;
        let allCoinsCount: number = 0;
        let stickyCoinsArray: string[][] = JSON.parse(JSON.stringify(DevilsCrossRoad.model.data.stickyCoins));
        stickyCoinsArray.pop();
        stickyCoinsArray.forEach(item => {
            item.shift();
        });
        if (area === "top") {
            stickyCoinsArray[blockId].forEach(item => {
                if (item !== "X") {
                    allCoinsCount++;
                }
            })
        } else if (area === "right") {
            stickyCoinsArray.forEach(item => {
                if (item[blockId] !== "X") {
                    allCoinsCount++;
                }
            })
        }
        if (allCoinsCount === 5) {
            isLineFull = true;
        }
        return isLineFull;
    }

    public unlockArea(area:string, blockId:number,isInit:boolean): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        if(area === "top" && !this._unlockedTopAreas[blockId]) {
            const trackIndex:number = 0;
            const animation1:PIXI.spine.core.Animation = this._topSpines[blockId].spineData.findAnimation("feature_activate");
            const animation2:PIXI.spine.core.Animation = this._topSpines[blockId].spineData.findAnimation("feature_active");
            const animationAlpha:number = 1;
            const mixDuration:number = 0;

            tl.add(() => {
                SpineGSAPWrapper.setAnimation(this._topSpines[blockId], trackIndex, animation1, false, animationAlpha, mixDuration);
                DevilsCrossRoad.freespinReelAreaView.playVerticalSequence(blockId);

            });
            tl.add(() => {
                if (!isInit && !this._unlockedTopAreas[blockId]) {
                    DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_FEATURE_ACTIVATE})
                }
            }, mixDuration);
            tl.add(() => SpineGSAPWrapper.setAnimation(this._topSpines[blockId], trackIndex, animation2, true, animationAlpha, mixDuration), animation1.duration);
            tl.add(() => {
                this._unlockedTopAreas[blockId] = true;
            });
        }
        else if(area === "right" && !this._unlockedRightAreas[blockId]) {
            const trackIndex:number = 0;
            const animation1:PIXI.spine.core.Animation = this._rightSpines[blockId].spineData.findAnimation("feature_activate");
            const animation2:PIXI.spine.core.Animation = this._rightSpines[blockId].spineData.findAnimation("feature_active");
            const animationAlpha:number = 1;
            const mixDuration:number = 0;

            tl.add(() => {
                SpineGSAPWrapper.setAnimation(this._rightSpines[blockId], trackIndex, animation1, false, animationAlpha, mixDuration);
                DevilsCrossRoad.freespinReelAreaView.playHorizontalSequence(blockId);
            });
            tl.add(() => {
                if (!isInit && !this._unlockedRightAreas[blockId]) {
                    DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_FEATURE_ACTIVATE})
                }
            }, mixDuration);
            tl.add(() => SpineGSAPWrapper.setAnimation(this._rightSpines[blockId], trackIndex, animation2, true, animationAlpha, mixDuration), animation1.duration);
            tl.add(() => {
                this._unlockedRightAreas[blockId] = true;
            });
        }

        return tl;
    }

    public onOrientationChanged() {
        if(NolimitApplication.isLandscape) {
            this.x = 0;

            this._reelFrameOverlay.position.set(-60, 32.5);

            const startXright:number = 655;
            const startXtop:number = 57.5;
            const startYtop:number = 140;
            const startYright:number = 235;

            const areaWidth:number = 120;
            const areaHeight:number = 100;

            [0, 1, 2, 3, 4].forEach((value) => {
                this._topSpines[value].position.set(startXtop + (value * areaWidth), startYtop);
                this._rightSpines[value].position.set(startXright, startYright + (value * areaHeight));
            });

            this._heartIndicatorSpine.position.set(655, 135);
            this._heartCounterOverlay.position.set(655, 135);

            this.resizeHorz("landscape");
            this.resizeVert("landscape");
        }
        else {
            this.x = -45;

            this._reelFrameOverlay.position.set(0, 4);

            const startXtopPort:number = 115;
            const startYtopPort:number = 100;
            const startXrightPort:number = 720;
            const startYrightPort:number = 205;

            const areaWidth:number = 120;
            const areaHeight:number = 100;

            [0, 1, 2, 3, 4].forEach((value) => {
                this._topSpines[value].position.set(startXtopPort + (value * areaWidth), startYtopPort);
                this._rightSpines[value].position.set(startXrightPort, startYrightPort + (value * areaHeight));
            });

            this._heartIndicatorSpine.position.set(715, 105);
            this._heartCounterOverlay.position.set(715, 105);

            this.resizeHorz("portrait");
            this.resizeVert("portrait");
        }
    }

    public resetSpinsFullCounter(): void {
        this._spinsFullCounter = 0;
    }

}